import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface StartInternalBookingParams {
	meetingConfigId: string;
	userIds: string[];
	timeZoneId?: string;
	contactId?: string;
}

interface UseStartInternalBookingMutationOptions {
	onSuccess?: (response: Api.IStartInternalBookingResponse) => void;
	onError?: (err: Api.IOperationResultNoValue) => void;
}

/**
 * Starts a booking session for a meeting type that also requires the given teammates to be available.
 * The response url opens the (anonymous) booking page already bound to this session.
 */
export function useStartInternalBookingMutation({ onSuccess, onError }: UseStartInternalBookingMutationOptions = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ meetingConfigId, userIds, timeZoneId, contactId }: StartInternalBookingParams) => {
			const request: Api.IStartInternalBookingRequest = {
				contactId,
				timeZoneId,
				userIds,
			};

			return userSession.webServiceHelper.callAsync<Api.IStartInternalBookingResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `scheduler/config/${encodeURIComponent(meetingConfigId)}/internalbooking`,
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
}
